// Onglets (ARIA)
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-tabs]').forEach(root => {
        const tabs = root.querySelectorAll('[role="tab"]');
        const panels = root.querySelectorAll('[role="tabpanel"]');
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const id = tab.getAttribute('aria-controls');
                tabs.forEach(t => t.setAttribute('aria-selected', String(t === tab)));
                panels.forEach(p => p.classList.toggle('is-active', p.id === id));
            });
        });
    });
});
